import { useEffect } from 'react'
import { useIsMac } from './usePlatform'

export const useHotKey = (keyCheck: (event: KeyboardEvent) => boolean, callback: VoidFunction): void => {
  useEffect(() => {
    const handleKeydown = (event: KeyboardEvent): void => {
      if (event.repeat) return
      if (keyCheck(event)) {
        event.preventDefault()
        callback()
      }
    }
    document.addEventListener('keydown', handleKeydown)
    return () => {
      document.removeEventListener('keydown', handleKeydown)
    }
  }, [keyCheck, callback])
}

export const useCmdHotKey = (string: string | string[], callback: VoidFunction): void => {
  const isMac = useIsMac()
  useHotKey((event) => {
    const cmdOrCtrlPressed = isMac ? event.metaKey : event.ctrlKey
    return cmdOrCtrlPressed && (Array.isArray(string) ? string.includes(event.key) : event.key === string)
  }, callback)
}
